import React, { Component } from 'react'
import { connect } from 'react-redux'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'
import ReportingBroadcastContainer from '../../../components/Insights/ReportingBroadcastContainer'
import ModalDialog from '../../../components/common/ModalDialog'
import {
  getBroadcasts,
  updateBroadcast,
  deleteBroadcast,
  createBroadcast,
  getDropdowns,
} from '../../../actions/insights'

const emptyBroadcast = {
  id: null,
  reportType: '',
  frequencyDescription: '',
  subscriberIds: '',
  enable: true,
  //** Transient values */
  description: '', //describe the frequency
  employee: '', //employee that creates the broadcast
  subscribers: [], //list of employee objects
}

class ReportingBroadcast extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openNewRow: false,
      isNewBroadcast: false,
      availableReports: [],
      availableFrequencies: [],
      employees: [],
      broadcasts: [],
      broadcastIdToDelete: null,
    }
  }

  async componentDidMount() {
    let broadcasts = await this.props.dispatch(getBroadcasts())
    let dropdownsInfo = await this.props.dispatch(getDropdowns())

    this.setState({
      availableReports: (dropdownsInfo && dropdownsInfo.reports) || [],
      availableFrequencies: (dropdownsInfo && dropdownsInfo.frequencies) || [],
      employees: (dropdownsInfo && dropdownsInfo.employees) || [],
      broadcasts: (broadcasts && broadcasts.values) || [],
    })
  }

  onAddNewBroadcast = () => {
    this.setState({
      isNewBroadcast: true,
      openNewRow: true,
    })
  }

  async onCreateBroadcast(data, afterOnSave) {
    if (!data.subscriberIds || data.subscriberIds == null || data.subscriberIds === '') {
      data.subscriberIds = []
    }
    if (
      data.subscriberEmailsExternal &&
      data.subscriberEmailsExternal !== null &&
      data.subscriberEmailsExternal.length > 0
    ) {
      let emails = data.subscriberEmailsExternal.map((subscriber) => subscriber.label)
      data.subscriberEmailsExternal = emails
    }
    await this.props.dispatch(createBroadcast(data))
    let broadcasts = await this.props.dispatch(getBroadcasts())
    this.setState(
      {
        broadcasts: (broadcasts && broadcasts.values) || [],
        isNewBroadcast: false,
        openNewRow: false,
      },
      () => {
        afterOnSave && afterOnSave()
      },
    )
  }

  async onUpdateBroadcast(data, afterOnSave) {
    if (!data.subscriberIds || data.subscriberIds == null || data.subscriberIds === '') {
      data.subscriberIds = []
    }
    if (
      data.subscriberEmailsExternal &&
      data.subscriberEmailsExternal !== null &&
      data.subscriberEmailsExternal.length > 0
    ) {
      let emails = data.subscriberEmailsExternal.map((subscriber) => subscriber.label)
      data.subscriberEmailsExternal = emails
    }
    await this.props.dispatch(updateBroadcast(data.id, data))
    let broadcasts = await this.props.dispatch(getBroadcasts())
    this.setState(
      {
        broadcasts: (broadcasts && broadcasts.values) || [],
        openNewRow: false,
      },
      () => {
        afterOnSave && afterOnSave()
      },
    )
  }

  openDeleteModal() {
    this.deleteModal.handleClickOpen()
  }

  async onDeleteBroadcast() {
    const { broadcastIdToDelete } = this.state
    await this.props.dispatch(deleteBroadcast(broadcastIdToDelete))
    let broadcasts = await this.props.dispatch(getBroadcasts())
    this.setState(
      {
        broadcasts: (broadcasts && broadcasts.values) || [],
        broadcastIdToDelete: null,
      },
      () => {
        this.deleteModal.handleClose()
      },
    )
  }

  render() {
    const {
      broadcasts = [],
      openNewRow,
      availableReports = [],
      availableFrequencies = [],
      isNewBroadcast,
      employees,
    } = this.state
    const allShops = JSON.parse(localStorage.getItem('session')).employeeShops || []
    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Button
            variant="raised"
            className="primary-button pull-right margin-bottom-small"
            onClick={this.onAddNewBroadcast}
          >
            Create Broadcast
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ paddingBottom: '130px' }}>
          <div className="table cus-pager-top">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Report Name</TableCell>
                  <TableCell>Frequency</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Created by</TableCell>
                  <TableCell>Shop(s)</TableCell>
                  <TableCell>Subscribers</TableCell>
                  <TableCell>External emails</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {openNewRow ? (
                  <ReportingBroadcastContainer
                    broadcast={emptyBroadcast}
                    availableReports={availableReports}
                    availableFrequencies={availableFrequencies}
                    employees={employees}
                    createBroadcast={(data, afterOnSave) => {
                      this.onCreateBroadcast(data, afterOnSave)
                    }}
                    onCancel={() => {
                      this.setState({
                        openNewRow: false,
                        isNewBroadcast: false,
                      })
                    }}
                    defaultEditMode={true}
                    isNewBroadcast={isNewBroadcast}
                    {...this.props}
                  />
                ) : null}
                {broadcasts.map((broadcast, index) => {
                  let listOfShops = broadcast.shopId.split(',')
                  let shops = ''
                  const numberOfShops = listOfShops.length
                  for (let i = 0; i < numberOfShops; i++) {
                    let idShop = listOfShops[i].replace(/'/g, '')
                    let shop = allShops.filter((x) => x.appTarget === 'Retail' && x.id === idShop)
                    let endString = i === numberOfShops - 1 ? '' : ', '
                    shops = shop && shop.length > 0 && shops + shop[0].name + endString
                  }
                  return (
                    <ReportingBroadcastContainer
                      key={index}
                      broadcast={broadcast}
                      updateBroadcast={(data, afterOnSave) => {
                        this.onUpdateBroadcast(data, afterOnSave)
                      }}
                      availableReports={availableReports}
                      availableFrequencies={availableFrequencies}
                      shops={shops}
                      employees={employees}
                      defaultEditMode={false}
                      onDelete={() => {
                        this.setState(
                          {
                            broadcastIdToDelete: broadcast.id,
                          },
                          () => this.openDeleteModal(),
                        )
                      }}
                      {...this.props}
                    />
                  )
                })}
              </TableBody>
            </Table>
          </div>
        </Grid>
        <ModalDialog
          ref={(c) => (this.deleteModal = c)}
          onConfirm={() => {
            this.onDeleteBroadcast()
          }}
          onClose={() => {
            this.setState({ broadcastIdToDelete: null })
          }}
          confirmText="Delete"
        >
          Are you sure you want to delete this broadcast? Your subscribers will lose their scheduled
          reports.'
        </ModalDialog>
      </Grid>
    )
  }
}

const ReportingBroadcastWithTitle = ContainerWithTitleWrapper(
  ReportingBroadcast,
  'Scheduled Exports',
)
const ReportingBroadcastConnected = connect(({ shopReducer, dispatch, authReducer }) => ({
  shopReducer,
  dispatch,
  authReducer,
}))(ReportingBroadcastWithTitle)

export default ReportingBroadcastConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Insights/ReportingBroadcast.js